import React, { useState } from 'react';
import useFetchHistoryData from '../hooks/useFetchHistoryData';
import { DataGrid, useGridApiContext, useGridSelector, gridPageSelector, gridPageCountSelector } from '@mui/x-data-grid';
import { Pagination } from '@mui/material';

function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
        <Pagination
            count={pageCount}
            page={page + 1}
            onChange={(_, value) => apiRef.current.setPage(value - 1)}
            showFirstButton
            showLastButton
            siblingCount={2}
            boundaryCount={1}
        />
    );
}

const columns = [
    { field: 'id',   headerName: 'ID',   flex: 2 },
    { field: 'name', headerName: '名稱', flex: 1 },
    { field: 'mac',  headerName: 'Mac',  flex: 2 },
    { field: 't',    headerName: '溫度', type: 'number', flex: 1 },
    { field: 'h',    headerName: '濕度', type: 'number', flex: 1 },
    { field: 'date', headerName: '時間', flex: 2 },
];

const History = () => {
    const [page, setPage]           = useState(0);
    const [pageSize, setPageSize]   = useState(10);
    const [floor, setFloor]         = useState(0);
    const [mac, setMac]             = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime]     = useState('');

    const { history, total, loading } = useFetchHistoryData(page, pageSize, floor, mac, startTime, endTime);

    return (
        <div className="history_wrapper">
            <div className="search_wrapper">
                <div>
                    <select id="floor" value={floor} onChange={(e) => setFloor(e.target.value)}>
                        <option>請選擇樓層</option>
                        <option value={1}>1 樓</option>
                        <option value={2}>2 樓</option>
                        <option value={3}>3 樓</option>
                        <option value={4}>4 樓</option>
                    </select>
                </div>
                <div>
                    <input
                        id="mac"
                        type="text"
                        placeholder="mac"
                        value={mac}
                        onChange={(e) => setMac(e.target.value)}
                    />
                </div>
                <div>
                    <input
                        id="startTime"
                        type="datetime-local"
                        value={startTime}
                        onChange={(e) => setStartTime(e.target.value)}
                    />
                </div>
                <div>
                    <input
                        id="endTime"
                        type="datetime-local"
                        value={endTime}
                        onChange={(e) => setEndTime(e.target.value)}
                    />
                </div>
            </div>
            <div className="data_grid_wrapper">
                <DataGrid
                    className="data_grid"
                    rows={history}
                    columns={columns}
                    rowCount={total}
                    loading={loading}
                    paginationModel={{ page, pageSize }}
                    onPaginationModelChange={(model) => {
                        setPage(model.page);
                        setPageSize(model.pageSize);
                    }}
                    paginationMode="server"
                    pageSizeOptions={[5, 10, 15, 20]}
                    slots={{ pagination: CustomPagination }}
                />
            </div>
        </div>
    );
};

export default History;
